<template>
  <div class="d-flex flex-wrap" :class="colclass">
    <d-label v-if="label" :label="label" />
    <div class="input-group">
      <input
        ref="input"
        type="text"
        class="form-control"
        :value="value[cod]"
        :readonly="readonly"
        :placeholder="placeholder"
        @keydown="getkeydown($event)"
        @input="updateValue($event.target.value)"
      >
      <div id="button-addon4" class="input-group-append">
        <button v-if="xsearch" class="btn btn-info" type="button" @click="openModal()"><i class="di di-search"></i></button>
        <button v-if="follow" class="btn btn-info" type="button" @click="dofollow()">➤</button>
      </div>
    </div>
    <!--<span :class="desclass">{{getdes}}</span>-->
    <span class="small">{{ getdes }}</span>
  </div>
</template>

<script>
    import { NextApiClient as Dau } from '@3cad/nextcore'
    import { bus } from '@store/dau'

    export default {
        props: {
            label: String,
            value: Object,
            cols: Number,
            placeholder: String,
            readonly: Boolean,
            small: Boolean,
            large: Boolean,
            noborder: Boolean,
            hidedes: Boolean,
            multiline: {type: Boolean, default: false},
            search: Object,
            table: String,
            follow: String,
            cod: {type: String, default: 'cod'},
            des: {type: String, default: 'des'},
            desnewline: {type: Boolean, default: false},
        },
        data () {
            return {
                ismodal: false
            }
        },
        computed: {
            user () {
                return this.$store.getters['getProfile']
            },
            xsearch () {
                if (this.search) return this.search
                if (this.table) {
                    var x = this.table
                    if (x.indexOf(',') > 0) {
                        return {
                            service: x.ex(',', 1),
                            func: x.ex(',', 2),
                            params: {
                                Catalogo: this.user.catalog || this.user.cats[0].cod,
                                Table: x.ex(',', 3),
                                Page: 1,
                                Rows: 20,
                                cOrder: 0,
                                cWhere: ''
                            }
                        }
                    } else {
                        return {
                            params: {
                                Catalogo: this.user.catalog || this.user.cats[0].cod,
                                Table: this.table,
                                Page: 1,
                                Rows: 20,
                                cOrder: 0,
                                cWhere: ''
                            }
                        }
                    }
                }
            },
            getcod () {
                return this.value[this.cod]
            },
            getdes () {
                var v = this.value[this.des]
                if (v && v.length > 30) v = v.substring(0, 30) + '..'
                return v
            },
            codclass () {
                return 'col connectright' + this.getsize()
            },
            btnclass () {
                var aa = 'btn btn-info '
                if (this.hidedes && !this.follow && !this.multiline)
                    aa = aa + 'connectleft';
                else
                    aa = aa + 'connect';

                return aa + this.getsize()
            },
            followclass () {
                return 'btn btn-warning connectleft follow ' + this.getsize()
            },
            /*  desclass() {
                var aa="col-x2 textbox";
                if (this.follow) aa=aa+" connect"; else aa=aa+" connectleft";
                return aa+this.getsize();
              }, */
            colclass () {
                if (this.cols && Number.isInteger(this.cols) && this.cols > 0 && this.cols < 13)
                    return 'col-' + this.cols
                else
                    return 'col'
            },
            desclass () {
                if (this.desnewline)
                    return ''
                else
                    return 'form-control input-group-text'
            }
        },
        methods: {
            openModal () {
                if (this.xsearch) {
                    this.$3cadComponent({
                        title: !this.label ? this.$parent.$parent.title : this.label,
                        size: 'xl',
                        component: 'd-search',
                        componentData: {
                            service: this.xsearch.service,
                            func: this.xsearch.func || 'HelperSearch',
                            params: this.xsearch.params
                        },
                        componentEvents: ['select']
                    }).then(res => {
                        let data = res.data;
                        var des = ''
                        if (data.des === undefined) {
                            if (data.desshort !== undefined) {
                                des = data.desshort
                            }
                        } else {
                            des = data.des
                        }
                        this.updateValue(data.cod, des)
                    }).catch(() => {})
                    /*this.$refs.search.open({
                          title: !this.label ? this.$parent.$parent.title : this.label,
                          module: this.xsearch.service,
                          func: this.xsearch.func,
                          params: this.xsearch.params
                        }).$once('close', (mode, data) => {
                            if(mode < 1)
                            var des = '';
                            if(data.des == undefined) {
                              if(data.desshort != undefined) {
                                des = data.desshort;
                              }
                            } else {
                              des = data.des;
                            }
                            this.updateValue(data.cod, des);
                            return;
                        })*/
                }
            },
            gosearch () {
                if (this.xsearch) this.ismodal = true
            },
            loadpage (cod) {
                if (!this.xsearch) return
                var sc = this
                var p = {
                    Page: 1,
                    Rows: 1,
                    cOrder: '',
                    cwhere: '0:' + cod
                }
                if (this.xsearch.params) p = Object.assign(p, this.xsearch.params)
                var func = this.xsearch.func ? this.xsearch.func : 'HelperSearch'
                var service = this.xsearch.service ? this.xsearch.service : 'helpers'
                Dau.com(service, func, p, d => {
                    if (d && d.data && d.data.records && d.data.records[0] && d.data.records[0][sc.cod]
                        && (cod + '').toUpperCase() == (d.data.records[0][sc.cod] + '').toUpperCase()) {
                        var res = {}
                        res[sc.cod] = d.data.records[0][sc.cod]
                        if (!sc.hidedes) res[sc.des] = d.data.records[0][sc.des]
                        this.$emit('input', res)
                    }
                })
            },
            getkeydown (e) {
                var sc = this
                switch (e.key) {
                    case '?':
                        this.ismodal = true
                        e.preventDefault()
                        break
                    case 'Enter':
                        var cod = sc.value[sc.cod]
                        if (cod) {
                            this.loadpage(cod)
                            e.preventDefault()
                        }
                        break
                }
            },
            updateValue (cod, des) {
                var sc = this
                var res = {}
                res[sc.cod] = cod != undefined ? cod : this.value[this.cod]
                res[sc.des] = des != undefined ? des : ''
                // ******* issue with codvar, coddes, codopz, desopz  **********
                if (sc.cod == 'codvar') {
                    sc.value.codvar = res[sc.cod]
                    sc.value.desvar = res[sc.des]
                } else if (sc.cod == 'codopz') {
                    sc.value.codopz = res[sc.cod]
                    sc.value.desopz = res[sc.des]
                } else {
                    sc.value.cod = res[sc.cod]
                    if (!this.hidedes) {
                        sc.value.des = res[sc.des]
                    }
                }
                // **************************************************************
                this.$emit('input', res)
            },
            load (e) {
                this.updateValue(e[this.cod], this.hidedes ? '' : e[this.des])
                this.ismodal = false
            },
            dofollow () {
                var sc = this
                var x = sc.follow.trim().split('#').join(sc.value[sc.cod])
                if (x) bus.$emit('routeadd', {cod: x})
            },
            getsize () {
                var aa = this.noborder ? ' noborder' : ''
                return this.small ? aa + ' small' : this.large ? aa + ' large' : ''
            }
        }
    }
</script>
<style scoped lang="scss">
   .multiline {
     display: block;
     color:$info;
     line-height:1.4rem;
     height: 1.4rem;
     overflow: hidden;
     font-size:0.8em;
     font-style: italic;
   }
   input {
      max-width: 200px;
      padding-left:5px;
   }
   span {
     min-width:200px;
   }
   .input-group-prepend, .input-group-append {
      display: inline-block;
    }

</style>




// WEBPACK FOOTER //
// src/_eng/globals/dcoddes.vue